webpackJsonp([18],{

/***/ 1089:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('app-banner', {
    attrs: {
      "banners": _vm.banners,
      "categories": _vm.eCategories,
      "type": _vm.bannerTypes.Home
    }
  }), _vm._v(" "), _c('app-filters', {
    attrs: {
      "filters": _vm.filters
    },
    on: {
      "filter-selected": _vm.filterSelected
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('products-by-category', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.isLoading),
        expression: "isLoading"
      }],
      key: category.id,
      attrs: {
        "is-loading": _vm.isLoading,
        "category": category,
        "products": category.products
      }
    })
  }), _vm._v(" "), _c('app-footer')], 2)
},staticRenderFns: []}

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1089),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3481be94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_helper__ = __webpack_require__(136);






var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
		var params, requests, _ref2, _ref3, filterExist;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							commerceId: id
						};
						requests = [this.$httpQtc.get('banners-public', { params: params }), this.$httpQtc.get('e-categories-public', { params: params }), this.$httpQtc.get('filters-public')];
						_context.next = 4;
						return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(requests);

					case 4:
						_ref2 = _context.sent;
						_ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 3);
						this.banners = _ref3[0].data;
						this.eCategories = _ref3[1].data;
						this.filters = _ref3[2].data;

						this.$bus.$emit('categories-data', this.eCategories);
						filterExist = this.getLocalStorage('filter-products');

						if (filterExist) {
							this.filterSelected(filterExist);
							this.filters = this.filters.map(function (f) {
								var newF = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, f);
								newF.active = false;
								if (newF.id === filterExist.id) {
									newF.active = true;
								}
								return newF;
							});
							this.removeLocalData('filter-products');
						}
						this.setPageTitle(this.getTitlePage);
						this.updateDescriptionTag(this.descriptionPage);

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData(_x) {
		return _ref.apply(this, arguments);
	};
}();

var filterProducts = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var queryIds, publicUrl, privateUrl, url, privateHeaders, headers, _ref5, products;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						queryIds = this.queryProducts.join(',');
						publicUrl = 'products-public?filters=' + queryIds;
						privateUrl = 'products/favorites?filters=' + queryIds;
						url = this.token ? privateUrl : publicUrl;
						privateHeaders = {
							Authorization: 'Bearer ' + this.token
						};
						headers = this.token ? privateHeaders : null;
						_context2.next = 8;
						return this.$httpQtc.get(url, { headers: headers });

					case 8:
						_ref5 = _context2.sent;
						products = _ref5.data;

						this.$store.commit('SET_PRODUCTS', products);

					case 11:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function filterProducts() {
		return _ref4.apply(this, arguments);
	};
}();

var loadCategories = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var headersToken, headers, publicService, privateService, urlService, params, _ref8;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						this.isLoading = true;
						headersToken = this.token || this.$store.state.publicToken;
						headers = {
							Authorization: 'Bearer ' + headersToken
						};
						publicService = 'products-public';
						privateService = 'products';
						urlService = this.token ? privateService : publicService;
						params = {
							flagGrouper: this.flagGrouper,
							sortDirection: 'asc',
							sortField: 'order'
						};
						_context3.prev = 7;
						_context3.next = 10;
						return this.$httpQtc.get(urlService + '/by-ecategories', { headers: headers, params: params });

					case 10:
						_ref8 = _context3.sent;
						this.categories = _ref8.data;

						this.updateProductsByCategories(this.categories);
						_context3.next = 18;
						break;

					case 15:
						_context3.prev = 15;
						_context3.t0 = _context3['catch'](7);

						if (_context3.t0.response.status === 500) {
							this.$message({
								message: 'Ocurrió un error en el servidor.',
								type: 'error',
								showClose: true
							});
						} else if (_context3.t0.response.status === 400) {
							if (_context3.t0.response.data.message === 'LIMIT_VISITS_NOT_CONFIGURED') {
								this.$message({
									message: 'No se ha configurado el límite de visitas para mostrar productos por categorías.',
									type: 'error',
									showClose: true
								});
							}
						}

					case 18:
						_context3.prev = 18;

						this.isLoading = false;
						return _context3.finish(18);

					case 21:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[7, 15, 18, 21]]);
	}));

	return function loadCategories() {
		return _ref7.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadCategories();
	this.objUser = this.getLocalStorage('user-info');
	if (this.objUser) {
		this.idCommerce = this.objUser.commerce ? this.objUser.commerce.id : '';
	}
	var id = this.idCommerce || this.getCommerceData.id;
	this.loadData(id);
}

function filterSelected(_ref6) {
	var id = _ref6.id;

	if (this.queryProducts.length === 0) {
		this.queryProducts.push(id);
		this.filterProducts();
	} else {
		var index = this.queryProducts.findIndex(function (itemId) {
			return itemId === id;
		});
		if (index === -1) {
			this.queryProducts = this.queryProducts.concat(id);
			this.filterProducts();
		} else {
			this.queryProducts.splice(index, 1);
			if (this.queryProducts.length > 0) {
				this.filterProducts();
			}
		}
	}
}

function beforeDestroy() {
	window.removeEventListener('scroll', this.scrollHandler);
}

function beforeRouteLeave(to, from, next) {
	this.$store.dispatch('loading', true);
	next();
}

function updateProductsByCategories(categories) {
	var salPriceId = this.getCommerceData.settings.salPriceListId;
	this.categories = categories.map(function (category) {
		var newCategory = category;
		newCategory.products = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_helper__["a" /* priceProductConfiguration */])(salPriceId, category.products);
		return newCategory;
	});
}

function data() {
	return {
		banners: [],
		categories: [],
		objUser: {},
		eCategories: [],
		filters: [1, 2],
		queryProducts: [],
		idCommerce: null
	};
}

function getCommerceData(value) {
	this.objUser = this.getLocalStorage('user-info');
	if (this.objUser) {
		this.idCommerce = this.objUser.commerce ? this.objUser.commerce.id : '';
	}
	if (value) {
		var id = this.idCommerce || value.id;
		this.loadData(id);
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Home',
	beforeDestroy: beforeDestroy,
	beforeRouteLeave: beforeRouteLeave,
	components: {
		appBanner: function appBanner() {
			return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1055));
		},
		appFilters: function appFilters() {
			return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1056));
		},
		appFooter: function appFooter() {
			return __webpack_require__.e/* import() */(27/* duplicate */).then(__webpack_require__.bind(null, 463));
		},
		productsByCategory: function productsByCategory() {
			return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1026));
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['allProductsLoaded', 'bannerTypes', 'flagGrouper', 'getSearchParams', 'getTitlePage', 'token', 'getCommerceData'])),
	created: created,
	data: data,
	methods: {
		filterProducts: filterProducts,
		filterSelected: filterSelected,
		loadCategories: loadCategories,
		loadData: loadData,
		updateProductsByCategories: updateProductsByCategories
	},
	watch: {
		getCommerceData: getCommerceData
	}
});

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(414)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans/OpenSans-Regular.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans/OpenSans-Bold.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans/OpenSans-SemiBold.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans/OpenSans-Light.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirMedium;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}.absolute[data-v-3481be94]{position:absolute}.align-center[data-v-3481be94]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.align-start[data-v-3481be94]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.align-end[data-v-3481be94]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.bgWhite[data-v-3481be94]{background-color:#fff}.black[data-v-3481be94]{color:#e9d628}.block[data-v-3481be94]{display:block}.bold[data-v-3481be94]{font-weight:700}.d-flex[data-v-3481be94]{display:-webkit-box;display:-ms-flexbox;display:flex}.disabled-btn[data-v-3481be94]{cursor:not-allowed;opacity:.25}.flex-column[data-v-3481be94]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.flex-5[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 5%;flex:1 1 5%}.flex-10[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 10%;flex:1 1 10%}.flex-15[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 15%;flex:1 1 15%}.flex-25[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 25%;flex:1 1 25%}.flex-20[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 20%;flex:1 1 20%}.flex-30[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 30%;flex:1 1 30%}.flex-40[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 40%;flex:1 1 40%}.flex-45[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 45%;flex:1 1 45%}.flex-50[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}.flex-60[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 60%;flex:1 1 60%}.flex-65[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 65%;flex:1 1 65%}.flex-70[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 70%;flex:1 1 70%}.flex-80[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 80%;flex:1 1 80%}.flex-95[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 95%;flex:1 1 95%}.flex-auto[data-v-3481be94]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.fontAvenir[data-v-3481be94]{font-family:AvenirMedium}.fontAvenirBold[data-v-3481be94]{font-family:AvenirBold}.fontOpenBold[data-v-3481be94]{font-family:Opens_semibold}.fontAvenirDemi[data-v-3481be94]{font-family:AvenirDemi}.fontS10[data-v-3481be94]{font-size:1rem}.fontS11[data-v-3481be94]{font-size:1.1rem}.fontS12[data-v-3481be94]{font-size:1.2rem}.fontS13[data-v-3481be94]{font-size:1.3rem}.fontS14[data-v-3481be94]{font-size:1.4rem}.fontS16[data-v-3481be94]{font-size:1.6rem}.fontS20[data-v-3481be94]{font-size:2rem}.h-100[data-v-3481be94]{height:100%}.justify-center[data-v-3481be94]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-end[data-v-3481be94]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.justify-start[data-v-3481be94]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-text[data-v-3481be94]{text-align:justify}.line-height-2[data-v-3481be94]{line-height:2rem}.m0[data-v-3481be94]{margin:0}.m-auto[data-v-3481be94]{margin:auto}.mb-1[data-v-3481be94]{margin-bottom:1rem}.mb-2[data-v-3481be94]{margin-bottom:2rem}.mb-3[data-v-3481be94]{margin-bottom:3rem}.mb-4[data-v-3481be94]{margin-bottom:4rem}.mb-6[data-v-3481be94]{margin-bottom:6rem}.mr-1[data-v-3481be94]{margin-right:1rem}.mr-2[data-v-3481be94]{margin-right:2rem}.mr-3[data-v-3481be94]{margin-right:3rem}.mx-1[data-v-3481be94]{margin-left:1rem;margin-right:1rem}.mx-2[data-v-3481be94]{margin-left:2rem;margin-right:2rem}.mx-3[data-v-3481be94]{margin-left:3rem;margin-right:3rem}.my-0[data-v-3481be94]{margin-bottom:0;margin-top:0}.my-1[data-v-3481be94]{margin-bottom:1rem;margin-top:1rem}.my-2[data-v-3481be94]{margin-bottom:2rem;margin-top:2rem}.my-3[data-v-3481be94]{margin-bottom:3rem;margin-top:3rem}.my-4[data-v-3481be94]{margin-bottom:4rem;margin-top:4rem}.mt-1[data-v-3481be94]{margin-top:1rem}.mt-2[data-v-3481be94]{margin-top:2rem}.mt-3[data-v-3481be94]{margin-top:3rem}.mt-4[data-v-3481be94]{margin-top:4rem}.mt-5[data-v-3481be94]{margin-top:5rem}.ml-1[data-v-3481be94]{margin-left:1rem}.ml-2[data-v-3481be94]{margin-left:2rem}.ml-3[data-v-3481be94]{margin-left:3rem}.mw-100[data-v-3481be94]{min-width:100%}.orange[data-v-3481be94]{color:#f703ff}.pb-1[data-v-3481be94]{padding-bottom:1rem}.pb-2[data-v-3481be94]{padding-bottom:2rem}.pb-3[data-v-3481be94]{padding-bottom:3rem}.pt-2[data-v-3481be94]{padding-top:2rem}.pt-3[data-v-3481be94]{padding-top:3rem}.pt-4[data-v-3481be94]{padding-top:4rem}.px-1[data-v-3481be94]{padding:0 1rem}.px-2[data-v-3481be94]{padding:0 2rem}.px-3[data-v-3481be94]{padding-left:3rem;padding-right:3rem}.px-4[data-v-3481be94]{padding:0 4rem}.px-5[data-v-3481be94]{padding-left:5rem;padding-right:5rem}.px-8[data-v-3481be94]{padding-left:8rem;padding-right:8rem}.py-1[data-v-3481be94]{padding:1rem 0}.py-2[data-v-3481be94]{padding-top:2rem;padding-bottom:2rem}.py-3[data-v-3481be94]{padding-top:3rem;padding-bottom:3rem}.py-4[data-v-3481be94]{padding-top:4rem;padding-bottom:4rem}.p2[data-v-3481be94]{padding:2rem}.p4[data-v-3481be94]{padding:4rem}.p6[data-v-3481be94]{padding:6rem}.relative[data-v-3481be94]{position:relative}.space-around[data-v-3481be94]{-ms-flex-pack:distribute;justify-content:space-around}.space-evenly[data-v-3481be94]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.space-between[data-v-3481be94]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.txt-center[data-v-3481be94]{text-align:center}.txt-left[data-v-3481be94]{text-align:left}.txt-right[data-v-3481be94]{text-align:right}.uppercase[data-v-3481be94]{text-transform:uppercase}.w-100[data-v-3481be94]{width:100%}.w-51[data-v-3481be94]{width:51%}.white-space[data-v-3481be94]{white-space:nowrap}.wrap[data-v-3481be94]{-ms-flex-wrap:wrap;flex-wrap:wrap}@media screen and (min-width:767px){.new-stuff[data-v-3481be94]{display:none}}.btn-whatsapp[data-v-3481be94]{display:none}@media (max-width:800px){.btn-whatsapp[data-v-3481be94]{bottom:5%;display:block;height:7rem;position:fixed;right:5%;width:7rem;z-index:99}.btn-whatsapp img[data-v-3481be94]{height:100%;width:100%}}", "", {"version":3,"sources":["/opt/build/repo/src/pages/Home.vue"],"names":[],"mappings":"AACA,WACE,0BAA6B,AAC7B,uDAAwD,AACxD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,oDAAqD,AACrD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,wDAAyD,AACzD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,qDAAsD,AACtD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,yBAA4B,AAC5B,6DAA8D,AAC9D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,0DAA2D,AAC3D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,0DAA2D,AAC3D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,2BACE,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,8BACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,4BACE,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CAC/B,AACD,0BACE,qBAAwB,CACzB,AACD,wBACE,aAAe,CAChB,AACD,wBACE,aAAe,CAChB,AACD,uBACE,eAAkB,CACnB,AACD,yBACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,+BACE,mBAAoB,AACpB,WAAc,CACf,AACD,8BACE,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,yBACE,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACtB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,4BACE,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CACxB,AACD,6BACE,wBAA4B,CAC7B,AACD,iCACE,sBAA0B,CAC3B,AACD,+BACE,0BAA8B,CAC/B,AACD,iCACE,sBAA0B,CAC3B,AACD,0BACE,cAAgB,CACjB,AACD,0BACE,gBAAkB,CACnB,AAID,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,cAAgB,CACjB,AACD,wBACE,WAAa,CACd,AACD,iCACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,8BACE,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,gCACE,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACrC,AACD,+BACE,kBAAoB,CACrB,AACD,gCACE,gBAAkB,CACnB,AACD,qBACE,QAAU,CACX,AACD,yBACE,WAAa,CACd,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,gBAAiB,AACjB,YAAc,CACf,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,yBACE,cAAgB,CACjB,AACD,yBACE,aAAe,CAChB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,qBACE,YAAc,CACf,AACD,qBACE,YAAc,CACf,AACD,qBACE,YAAc,CACf,AACD,2BACE,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,4BAA8B,CACnC,AACD,+BACE,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CACvC,AACD,gCACE,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,6BACE,iBAAmB,CACpB,AACD,2BACE,eAAiB,CAClB,AACD,4BACE,gBAAkB,CACnB,AACD,4BACE,wBAA0B,CAC3B,AACD,wBACE,UAAY,CACb,AACD,uBACE,SAAW,CACZ,AACD,8BACE,kBAAoB,CACrB,AACD,uBACE,mBAAoB,AAChB,cAAgB,CACrB,AACD,oCACA,4BACI,YAAc,CACjB,CACA,AACD,+BACE,YAAc,CACf,AACD,yBACA,+BACM,UAAW,AACX,cAAe,AACf,YAAa,AACb,eAAgB,AAChB,SAAU,AACV,WAAY,AACZ,UAAY,CACjB,AACD,mCACQ,YAAa,AACb,UAAY,CACnB,CACA","file":"Home.vue","sourcesContent":["\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirMedium';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirBold';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirDemi';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n.absolute[data-v-3481be94] {\n  position: absolute;\n}\n.align-center[data-v-3481be94] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.align-start[data-v-3481be94] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.align-end[data-v-3481be94] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.bgWhite[data-v-3481be94] {\n  background-color: white;\n}\n.black[data-v-3481be94] {\n  color: #e9d628;\n}\n.block[data-v-3481be94] {\n  display: block;\n}\n.bold[data-v-3481be94] {\n  font-weight: bold;\n}\n.d-flex[data-v-3481be94] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.disabled-btn[data-v-3481be94] {\n  cursor: not-allowed;\n  opacity: 0.25;\n}\n.flex-column[data-v-3481be94] {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.flex-5[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 5%;\n          flex: 1 1 5%;\n}\n.flex-10[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 10%;\n          flex: 1 1 10%;\n}\n.flex-15[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 15%;\n          flex: 1 1 15%;\n}\n.flex-25[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 25%;\n          flex: 1 1 25%;\n}\n.flex-20[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 20%;\n          flex: 1 1 20%;\n}\n.flex-30[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 30%;\n          flex: 1 1 30%;\n}\n.flex-40[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 40%;\n          flex: 1 1 40%;\n}\n.flex-45[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 45%;\n          flex: 1 1 45%;\n}\n.flex-50[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 50%;\n          flex: 1 1 50%;\n}\n.flex-60[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 60%;\n          flex: 1 1 60%;\n}\n.flex-65[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 65%;\n          flex: 1 1 65%;\n}\n.flex-70[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 70%;\n          flex: 1 1 70%;\n}\n.flex-80[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 80%;\n          flex: 1 1 80%;\n}\n.flex-95[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 95%;\n          flex: 1 1 95%;\n}\n.flex-auto[data-v-3481be94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n.fontAvenir[data-v-3481be94] {\n  font-family: \"AvenirMedium\";\n}\n.fontAvenirBold[data-v-3481be94] {\n  font-family: \"AvenirBold\";\n}\n.fontOpenBold[data-v-3481be94] {\n  font-family: \"Opens_semibold\";\n}\n.fontAvenirDemi[data-v-3481be94] {\n  font-family: \"AvenirDemi\";\n}\n.fontS10[data-v-3481be94] {\n  font-size: 1rem;\n}\n.fontS11[data-v-3481be94] {\n  font-size: 1.1rem;\n}\n.fontS13[data-v-3481be94] {\n  font-size: 1.3rem;\n}\n.fontS12[data-v-3481be94] {\n  font-size: 1.2rem;\n}\n.fontS13[data-v-3481be94] {\n  font-size: 1.3rem;\n}\n.fontS14[data-v-3481be94] {\n  font-size: 1.4rem;\n}\n.fontS16[data-v-3481be94] {\n  font-size: 1.6rem;\n}\n.fontS20[data-v-3481be94] {\n  font-size: 2rem;\n}\n.h-100[data-v-3481be94] {\n  height: 100%;\n}\n.justify-center[data-v-3481be94] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.justify-end[data-v-3481be94] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.justify-start[data-v-3481be94] {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.justify-text[data-v-3481be94] {\n  text-align: justify;\n}\n.line-height-2[data-v-3481be94] {\n  line-height: 2rem;\n}\n.m0[data-v-3481be94] {\n  margin: 0;\n}\n.m-auto[data-v-3481be94] {\n  margin: auto;\n}\n.mb-1[data-v-3481be94] {\n  margin-bottom: 1rem;\n}\n.mb-2[data-v-3481be94] {\n  margin-bottom: 2rem;\n}\n.mb-3[data-v-3481be94] {\n  margin-bottom: 3rem;\n}\n.mb-4[data-v-3481be94] {\n  margin-bottom: 4rem;\n}\n.mb-6[data-v-3481be94] {\n  margin-bottom: 6rem;\n}\n.mr-1[data-v-3481be94] {\n  margin-right: 1rem;\n}\n.mr-2[data-v-3481be94] {\n  margin-right: 2rem;\n}\n.mr-3[data-v-3481be94] {\n  margin-right: 3rem;\n}\n.mx-1[data-v-3481be94] {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.mx-2[data-v-3481be94] {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.mx-3[data-v-3481be94] {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.my-0[data-v-3481be94] {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.my-1[data-v-3481be94] {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n.my-2[data-v-3481be94] {\n  margin-bottom: 2rem;\n  margin-top: 2rem;\n}\n.my-3[data-v-3481be94] {\n  margin-bottom: 3rem;\n  margin-top: 3rem;\n}\n.my-4[data-v-3481be94] {\n  margin-bottom: 4rem;\n  margin-top: 4rem;\n}\n.mt-1[data-v-3481be94] {\n  margin-top: 1rem;\n}\n.mt-2[data-v-3481be94] {\n  margin-top: 2rem;\n}\n.mt-3[data-v-3481be94] {\n  margin-top: 3rem;\n}\n.mt-4[data-v-3481be94] {\n  margin-top: 4rem;\n}\n.mt-5[data-v-3481be94] {\n  margin-top: 5rem;\n}\n.ml-1[data-v-3481be94] {\n  margin-left: 1rem;\n}\n.ml-2[data-v-3481be94] {\n  margin-left: 2rem;\n}\n.ml-3[data-v-3481be94] {\n  margin-left: 3rem;\n}\n.mw-100[data-v-3481be94] {\n  min-width: 100%;\n}\n.orange[data-v-3481be94] {\n  color: #f703ff;\n}\n.pb-1[data-v-3481be94] {\n  padding-bottom: 1rem;\n}\n.pb-2[data-v-3481be94] {\n  padding-bottom: 2rem;\n}\n.pb-3[data-v-3481be94] {\n  padding-bottom: 3rem;\n}\n.pt-2[data-v-3481be94] {\n  padding-top: 2rem;\n}\n.pt-3[data-v-3481be94] {\n  padding-top: 3rem;\n}\n.pt-4[data-v-3481be94] {\n  padding-top: 4rem;\n}\n.px-1[data-v-3481be94] {\n  padding: 0 1rem;\n}\n.px-2[data-v-3481be94] {\n  padding: 0 2rem;\n}\n.px-3[data-v-3481be94] {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.px-4[data-v-3481be94] {\n  padding: 0 4rem;\n}\n.px-5[data-v-3481be94] {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n.px-8[data-v-3481be94] {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.py-1[data-v-3481be94] {\n  padding: 1rem 0;\n}\n.py-2[data-v-3481be94] {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.py-3[data-v-3481be94] {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.py-4[data-v-3481be94] {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.p2[data-v-3481be94] {\n  padding: 2rem;\n}\n.p4[data-v-3481be94] {\n  padding: 4rem;\n}\n.p6[data-v-3481be94] {\n  padding: 6rem;\n}\n.relative[data-v-3481be94] {\n  position: relative;\n}\n.space-around[data-v-3481be94] {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.space-evenly[data-v-3481be94] {\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n}\n.space-between[data-v-3481be94] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.txt-center[data-v-3481be94] {\n  text-align: center;\n}\n.txt-left[data-v-3481be94] {\n  text-align: left;\n}\n.txt-right[data-v-3481be94] {\n  text-align: right;\n}\n.uppercase[data-v-3481be94] {\n  text-transform: uppercase;\n}\n.w-100[data-v-3481be94] {\n  width: 100%;\n}\n.w-51[data-v-3481be94] {\n  width: 51%;\n}\n.white-space[data-v-3481be94] {\n  white-space: nowrap;\n}\n.wrap[data-v-3481be94] {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n@media screen and (min-width: 767px) {\n.new-stuff[data-v-3481be94] {\n    display: none;\n}\n}\n.btn-whatsapp[data-v-3481be94] {\n  display: none;\n}\n@media (max-width: 800px) {\n.btn-whatsapp[data-v-3481be94] {\n      bottom: 5%;\n      display: block;\n      height: 7rem;\n      position: fixed;\n      right: 5%;\n      width: 7rem;\n      z-index: 99;\n}\n.btn-whatsapp img[data-v-3481be94] {\n        height: 100%;\n        width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(842);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(415)("41f0f623", content, true);

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.11aab8a035a291f59661.js